import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classNames from 'classnames';

import * as AuthFormActions from 'rebook/apps/users/actions/AuthFormActions';

import AuthForm from '../AuthForm';
import styles from './style.scss';


class AuthFormDialog extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    document.querySelector('body').classList.add('isNotScrollable');
  }

  componentWillUnmount() {
    document.querySelector('body').classList.remove('isNotScrollable');
  }

  render() {
    return (
      <div
        className="transparentOverlay"
        onClick={(event) => {
          // hide the form if user clicked anywhere on the screen, except for the form itself
          event.target.getAttribute('data-window') && this.props.AuthFormActions.hideForm();
        }}
        data-window>
        <div className="col-xs-4">
          <div className={classNames(styles.content, 'billetContainer')}>
            <div className={styles.inner}>
              <div className={styles.close}
                onClick={(event) => {
                  event.preventDefault();
                  this.props.AuthFormActions.hideForm();
                }}>
                <div className={styles.cross} />
              </div>
              <AuthForm displaySocialAuth {...this.props} GALabel="TinyLogin" />
            </div>
          </div>
        </div>
      </div>
    );
  }
};

function mapDispatchToProps(dispatch) {
  return {
    AuthFormActions: bindActionCreators(AuthFormActions, dispatch),
  };
}

export default connect(null, mapDispatchToProps)(AuthFormDialog);
